import "yuki-createjs";

// tslint:disable-next-line:no-var-requires
require("src/assets/css/style.css");

import * as $ from "jquery";
import Stage = createjs.Stage;
import Utils from "lib/src/utils";
import Stamping from "src/Stamping";

const $window = $(window);
$window.ready(() => {
    const canvas = document.getElementById("canvas") as HTMLCanvasElement;
    canvas.width = $window.width();
    canvas.height = $window.height();
    Utils.init(canvas);

    new Stamping().start(canvas);
});



// WEBPACK FOOTER //
// ./~/string-replace-webpack-plugin/loader.js?id=bhaatt02qcw!./src/main.ts